










































import { Component, Vue, Prop } from "vue-property-decorator";
import { AuthApi } from "@/core/auth";
import { RoomApi, IRoom } from "@/core/room";
import store from "@/store";
import * as C from "@/common";

@Component
export default class RoomSelection extends Vue {
	public Rooms: IRoom[] = [];

	@Prop() private value!: string;

	public mounted() {
		this.LoadRoomData();
	}
	private async LoadRoomData() {
		const api = new RoomApi();

		this.Rooms = await api.load();
	}
	private async SelectRoom(event: any, room: IRoom) {
		if (+room.Registrations >= +room.Beds && !+room.OwnReg)
			return;
		// this.value = +room.ID;
		this.$emit("input", room.ID);
	}
}
